<template>
  <div>
    <b-row class="pt-2 pb-1">
      <b-col cols="6" class="d-flex align-items-center">
        <BreadcrumbMenu />
      </b-col>
      <b-col cols="6" class="pr-3 text-right">
        <button-filters
          @show-modal="$root.$emit('bv::show::modal', $event)"
          :filters-count="filtersCount"
          @clear-search-filters="clearSearchFilters"
        />
      </b-col>
    </b-row>

    <filter-modal @action="buildFilters()" @clear="clearSearchFilters()">
      <template v-slot:main-filters>
        <filters-component
          :panel-options="panelOptions"
          :panel-filter.sync="panelFilter"
          :start-datetime.sync="startDatetimeFilter"
          :end-datetime.sync="endDatetimeFilter"
        />
      </template>
    </filter-modal>

    <!-- Table Container Card -->
    <bosch-logs-component
      ref="refListTable"
      :currentPage="currentPage"
      :dataMeta="dataMeta"
      :fetchList="fetchList"
      :isSortDirDesc="isSortDirDesc"
      :perPage="perPage"
      :perPageOptions="perPageOptions"
      :searchQuery.sync="searchQuery"
      :sortBy="sortBy"
      :tableColumns="tableColumns"
      :totalList="totalList"
      @per-page="perPageValue"
      @update="update"
      @refresh-data="refreshData"
    >
      <template #search>
        <faceted-search
          :value="facetedFilters"
          :options="searchOptions"
          class="mr-1 bosch-logs-search-input"
          @search="setFacetedFilters"
        />
      </template>
    </bosch-logs-component>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BButton,
  BDropdown,
  BDropdownItem,
  BPagination,
  BInputGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref } from "@vue/composition-api";
import useList from "./useList";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import Pagination from "@/components/Pagination.vue";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import FiltersComponent from "../components/FiltersComponent";
import ButtonFilters from "@/components/Filters/ButtonFilters.vue";
import FilterModal from "@/components/Filters/FilterModal.vue";
import BoschLogsComponent from "../components/BoschLogsComponent.vue";
import FacetedSearch from "@/components/FacetedSearch.vue";

export default {
  components: {
    Pagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    vSelect,
    ToastificationContent,
    BreadcrumbMenu,
    FiltersComponent,
    ButtonFilters,
    FilterModal,
    BoschLogsComponent,
    FacetedSearch,
  },
  computed: {
    searchOptions() {
      return [
        { label: this.$t("bosch.eventCode"), value: "event_definition", isArray: false },
        { label: this.$t("bosch.deviceType"), value: "device_type", isArray: false },
        { label: this.$t("bosch.deviceId"), value: "device_id", isArray: false },
        { label: this.$t("bosch.deviceName"), value: "device_name", isArray: false },
        { label: this.$t("bosch.areaId"), value: "area_id", isArray: false },
        { label: this.$t("bosch.area"), value: "area_name", isArray: false },
        { label: this.$t("bosch.username"), value: "user_name", isArray: false },
        { label: this.$t("bosch.description"), value: "description", isArray: false },
      ];
    },
  },

  setup(_, context) {
    //start pagination
    const perPageValue = (data) => {
      perPage.value = data;
    };

    const update = (data) => {
      currentPage.value = data;
    };
    //end pagination

    const { t } = useI18nUtils();

    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      clearSearchFilters,
      buildFilters,
      filtersCount,
      setFacetedFilters,
      facetedFilters,
      idBoschProfile,

      panelFilter,
      panelOptions,
      startDatetimeFilter,
      endDatetimeFilter,
    } = useList();

    const itemFilter = ref();

    const addItemFilter = (data) => {
      itemFilter.value = data;
    };
    const addItemFilterSearch = (data) => {
      data.forEach((element) => {
        if (nameNav.value === element.text) {
          searchQuery.value = element.searchQuery;
        }
      });
    };
    const nameNav = ref("breadcrumbs.iot.bosch.log");

    // On Click the refresh button
    const refreshData = () => refetchData();

    return {
      nameNav,
      addItemFilter,
      itemFilter,
      addItemFilterSearch,

      update,
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,

      clearSearchFilters,
      buildFilters,
      filtersCount,

      idBoschProfile,

      panelOptions,
      panelFilter,
      startDatetimeFilter,
      endDatetimeFilter,

      perPageValue,
      refreshData,
      setFacetedFilters,
      facetedFilters,
    };
  },
};
</script>

<style scoped lang="scss">
.bosch-logs-search-input {
  flex: 1 1 0;
  min-width: 0;
}
</style>
